import { IStock } from '@notino/shared/definitions/custom-definitions';

import { getRenderableAttributes } from '@components/Tags/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';

import { useShouldRenderTagDiscount } from './shouldRenderTagDiscount';

export const useShouldRenderEligibleAction = () => {
  const { currentVariant } = useProductDetailContext();
  const shouldRenderTags = useShouldRenderTagDiscount(currentVariant);
  const hasVoucherDiscount = !!useResolvedVoucherDiscount();

  if (
    !shouldRenderTags ||
    hasVoucherDiscount ||
    currentVariant.stockAvailability.code === IStock.outOfStock
  ) {
    return false;
  }

  const attributes = getRenderableAttributes(currentVariant.attributes);
  const isEligible = currentVariant?.recentMinPrice?.isActionEligible;

  return Boolean(attributes.Action) && isEligible;
};
